import axios from 'axios'

// Le `detail` d'une erreur FastAPI, sinon un message par défaut. Module à part (pas dans un
// fichier de composant) : la règle react-refresh/only-export-components veut qu'un fichier
// de composant n'exporte que des composants.
export function detailErreur(e: unknown, defaut: string): string {
  if (axios.isAxiosError(e)) return texteDetail(e.response?.data?.detail, defaut)
  return defaut
}

// Un `detail` toujours affichable : FastAPI renvoie une LISTE d'objets sur une erreur de validation
// (422), qu'un rendu JSX ferait planter (revue #890). Mot de passe trop long : message dédié.
export function texteDetail(d: unknown, defaut: string): string {
  if (typeof d === 'string') return d
  if (Array.isArray(d)) {
    const tropLong = d.some((x) => {
      const e = x as { type?: unknown; loc?: unknown }
      return e?.type === 'string_too_long' && Array.isArray(e.loc) && e.loc.some((l) => /password/.test(String(l)))
    })
    if (tropLong) return 'Le mot de passe ne doit pas dépasser 128 caractères.'
  }
  return defaut
}
